/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Document Cognition Service
 * OpenAPI spec version: 1.0.0
 */

/**
 * Model to use for completions.

Unrecognized model strings (including retired Google/OpenAI variants
from older data) deserialize to `Retired` via the manual
`Deserialize` impl.
 */
export type AgentModel = (typeof AgentModel)[keyof typeof AgentModel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgentModel = {
  smart: 'smart',
  fast: 'fast',
  opus4_7: 'opus4_7',
  sonnet4_6: 'sonnet4_6',
  haiku4_5: 'haiku4_5',
  retired: 'retired',
} as const;
